<template>
  <el-switch
      v-model="paidValue"
      active-color="#13ce66"
      @change="changeValue"
  />
</template>

<script>
  export default {
    props: {
      paid: {
        type: Boolean
      },

      documentId: {
        type: Number
      }
    },

    data() {
      return {
        paidValue: false
      }
    },

    mounted() {
      this.paidValue = this.paid
    },

    methods: {
      changeValue() {
        this.$axios.post(`/app/documents/${this.documentId}/paid`).then(responce => {
          let data = responce.data
          let el = document.getElementById(`document_${this.documentId}`)
          let el_payments = document.getElementById(`row__document_${this.documentId}_payments`)

          if (el_payments) {
            el_payments.innerHTML = data.payments_block
          }

          if (data.paid) {
            el.classList.remove('danger')
          } else {
            el.classList.add('danger')
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>